import routes from '@/routes'
import { RoleType } from '@/enums/role.enum'
import PlayerCardPage from '@/views/pages/player-card/index.page'

import ContributionsPage from '@/views/pages/contributions/index.page'
import SportROCalculatorPage from '@/views/pages/sports-ro-calculator/index.page'
import HOME from '../../pages/home/index.page'

import BonusEngine from '../../pages/bonus/index.page'
import BonusEngineForm from '../../pages/bonus-form/index.page'
import WalletsPage from '../../pages/wallets/index.page'

import TransactionPage from '../../pages/transactions/index.page'
import UsersPage from '../../pages/users/index.page'
import ReportsPage from '../../pages/reports/index.page'
import BalanceReportPage from '../../pages/reports/balance.page'

import PlayerSearchPage from '../../pages/player-search/index.page'

/**
 * List of routes with the role access.
 * The route is added only if the role has access to the route. It depends the permissions of the user
 */

const rolesRoutes = [
  {
    path: routes.HOME,
    render: <HOME />,
    roles: [
      `${RoleType.SUPER_ADMIN}`,
      `${RoleType.AGENT}`,
      `${RoleType.MANAGER}`,
    ],
    hideSiteId: '',
  },
  {
    path: routes.bonus.INDEX,
    render: <BonusEngine />,
    roles: [
      `${RoleType.SUPER_ADMIN}`,
      `${RoleType.AGENT}`,
      `${RoleType.MANAGER}`,
    ],
    hideSiteId: '-1', // Not visible to ADMIN_VIEW
  },
  {
    path: routes.bonus.CREATE_BONUS,
    render: <BonusEngineForm />,
    roles: [`${RoleType.SUPER_ADMIN}`, `${RoleType.MANAGER}`],
    hideSiteId: '-1',
  },
  {
    path: routes.bonus.UPDATE_BONUS_ID,
    render: <BonusEngineForm />,
    roles: [`${RoleType.SUPER_ADMIN}`, `${RoleType.MANAGER}`],
    hideSiteId: '-1',
  },
  {
    path: routes.bonus.DUPLICATE_BONUS_ID,
    render: <BonusEngineForm />,
    roles: [`${RoleType.SUPER_ADMIN}`, `${RoleType.MANAGER}`],
    hideSiteId: '-1',
  },
  {
    path: routes.wallets.INDEX,
    render: <WalletsPage />,
    roles: [
      `${RoleType.SUPER_ADMIN}`,
      `${RoleType.AGENT}`,
      `${RoleType.MANAGER}`,
    ],
    hideSiteId: '-1',
  },
  {
    path: routes.transactions.INDEX,
    render: <TransactionPage />,
    roles: [
      `${RoleType.SUPER_ADMIN}`,
      `${RoleType.AGENT}`,
      `${RoleType.MANAGER}`,
    ],
    hideSiteId: '-1',
  },
  {
    path: routes.contributions.INDEX,
    render: <ContributionsPage />,
    roles: [
      `${RoleType.SUPER_ADMIN}`,
      `${RoleType.AGENT}`,
      `${RoleType.MANAGER}`,
    ],
    hideSiteId: '-1',
  },
  {
    path: routes.users.INDEX,
    render: <UsersPage />,
    roles: [`${RoleType.SUPER_ADMIN}`],
    hideSiteId: '',
  },
  {
    path: routes.users.EDIT,
    render: <UsersPage />,
    roles: [`${RoleType.SUPER_ADMIN}`],
    hideSiteId: '',
  },
  {
    path: routes.reports.INDEX,
    render: <ReportsPage />,
    roles: [
      `${RoleType.SUPER_ADMIN}`,
      `${RoleType.AGENT}`,
      `${RoleType.MANAGER}`,
    ],
    hideSiteId: '',
  },
  {
    path: routes.reports.BALANCE,
    render: <BalanceReportPage />,
    roles: [
      `${RoleType.SUPER_ADMIN}`,
      `${RoleType.AGENT}`,
      `${RoleType.MANAGER}`,
    ],
    hideSiteId: '',
  },
  {
    path: routes.sportsROCalculator.INDEX,
    render: <SportROCalculatorPage />,
    roles: [
      `${RoleType.SUPER_ADMIN}`,
      `${RoleType.AGENT}`,
      `${RoleType.MANAGER}`,
    ],
    hideSiteId: '',
  },
  {
    path: routes.playerCard.PLAYER_CARD_ID,
    render: <PlayerCardPage />,
    roles: [
      `${RoleType.SUPER_ADMIN}`,
      `${RoleType.AGENT}`,
      `${RoleType.MANAGER}`,
    ],
    hideSiteId: '',
  },
  {
    path: routes.playerCard.SEARCH_PLAYERS,
    render: <PlayerSearchPage />,
    roles: [
      `${RoleType.SUPER_ADMIN}`,
      `${RoleType.AGENT}`,
      `${RoleType.MANAGER}`,
    ],
    hideSiteId: '',
  },
]

export default rolesRoutes
